module.exports = __webpack_public_path__ + "static/media/invite-button-mobile.6ec0b85a.svg";